import moment from "moment-timezone";

require("moment/locale/ja");
moment.tz.setDefault("Asia/Tokyo");

export default moment;
